import Link from 'next/link'
import { LinkRecord } from 'types'

export const LinkBlock = ({ record }: { record: LinkRecord }) => {
  return <Link href={record.url}>{record.title}</Link>
}
